import React, { CSSProperties, useState } from "react";
import styled from "styled-components/macro";
import FieldTemplateWithError, {
  IFieldTemplate,
} from "../FieldTemplateWithError";
import { fieldBase } from "../Form";
interface InputProps extends fieldBase<string> {
  style?: CSSProperties;
  maxLength?: number;
  onFocus?: (value: string) => void;
  onBlur?: (value: string) => void;
  onClick?: (e: React.MouseEvent<HTMLTextAreaElement, MouseEvent>) => void;
}

const InputInner = styled.textarea`
  border: none;
  width: 100%;
  font: inherit;
  height: auto;
  resize: none;
  pointer-events: auto;
  background-color: transparent;
  padding: 0;
`;

const FieldTemplateAsLabel = ({
  children,
  ...props
}: React.PropsWithChildren<IFieldTemplate>) => {
  return (
    <FieldTemplateWithError as="label" {...props}>
      {children}
    </FieldTemplateWithError>
  );
};

const FieldTemplateStyled = styled(FieldTemplateAsLabel)<
  React.PropsWithChildren<IFieldTemplate>
>`
  display: flex;
`;

const Textarea = (props: InputProps) => {
  const [active, setActive] = useState<boolean>(false);

  const value = props.value;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange?.(e.target.value);
  };
  const handleFocus = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setActive(true);
    props.onFocus?.(e.target.value);
  };
  const handleBlur = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setActive(false);
    props.onBlur?.(e.target.value);
  };
  const onClick = (e: React.MouseEvent<HTMLTextAreaElement, MouseEvent>) => {
    props.onClick?.(e);
  };
  return (
    <FieldTemplateStyled
      editabel={!props.readOnly}
      disable={props.disabled}
      className={props.className}
      active={active}
      style={props.style}
      error={props.error}
      errorText={props.errorText}
    >
      <InputInner
        value={props.onChange ? props.value : value}
        onChange={handleChange}
        maxLength={props.maxLength}
        placeholder={props.placeholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={props.readOnly || props.disabled}
        onClick={onClick}
      />
    </FieldTemplateStyled>
  );
};

export default Textarea;
